import DuckEntity from './DuckEntity';
import DuckEntityForm from './DuckEntityForm';

const entity = new DuckEntity('billingContacts');

const billingContactForm = new DuckEntityForm('billingContactForm', entity, {
  initialState: {
    billing_payers: []
  },
  transformLoad: (model) => {
    const {
      billing_payers,
      school_year,
      contact,
      ...transformedModel
    } = model;

    const result = {
      ...transformedModel,
      billing_payers: billing_payers ? billing_payers.map((billing_payer) => ({
        ...billing_payer,
        id: billing_payer.id || `payer-${Math.random()}`,
      })) : []
    };

    if (school_year) {
      result['school_year_id'] = school_year.id;
    }

    if (contact) {
      result['contact_id'] = contact.id;
    }

    return result;
  },
  transformSave: (model) => {

    // noinspection JSUnusedLocalSymbols
    const {
      billing_payers,
      errors,
      ...transformedModel
    } = model;

    return {
      ...transformedModel,
      billing_payers: billing_payers.map((billing_payer) => {
        // noinspection JSUnusedLocalSymbols
        const {id, ...object} = billing_payer;

        return object;
      })
    }
  }
});

export { entity, billingContactForm };